import React from 'react'

import { Link } from 'react-router-dom';

import {
  Container,
  Amount,
  TypeService,
  Text,
  Icon
} from './styles'

import { colors } from 'stylesheets'

import iconProfile from 'assets/img/icons/profile.svg';
import calendar from 'assets/img/icons/calendar-ticket.svg'
import money from 'assets/img/icons/money-bold.svg'
import pdf from 'assets/img/icons/pdf.svg'

import Image from 'components/Image';

import { gaSendEvent } from '../../../../utils/analytics';
import { getDate } from '../../../../utils/date';

const Row = ({ ticket, invoice }) => {

  const data = invoice || ticket
  const taskIcon = data.service_icon && require(`assets/img/task-icons/${data.service_icon}`);

  const getStatusColorTicket = () => {
    switch (data.status) {
      case 'paid':
        return colors.success
      case 'created':
        return colors.greyDark
      case 'viewed':
        return colors.greyDark
      case 'expired':
        return colors.danger
    }
  }
  const getStatusColorInvoice = () => {
    return data.is_paid ? colors.success : colors.greyDark
  }

  const getStatusTicket = () => {

    switch (data.status) {
      case 'paid':
        return `Pago dia ${getDate(data.paid_date)}`
      case 'created':
        return `Vence dia ${getDate(data.due_date)}`
      case 'viewed':
        return `Vence dia ${getDate(data.due_date)}`
      case 'expired':
        return `Vencido desde ${getDate(data.due_date)}`
    }
  }

  const getStatusInvoice = () => {
    const text = data.is_paid ? 'Pago dia ' : 'Pendente desde '
    return `${text} ${getDate(data.charge_date)}`
  }

  const openNfs = () => {
    gaSendEvent('baixar_nota', 'nfs');
    window.open(data.invoice_url || `https://drive.google.com/viewerng/viewer?embedded=true&url=${data.file_url}`, '_blank');
  };

  return (
    <Container>
      {ticket && (
        <Amount>
          <Text primary marginbottom={`0`} color={colors.greyDark}>R$</Text>
          <Text primary color={colors.greyDark} fontsize={18} marginbottom={`0`}>{data.amount && data.amount.toLocaleString("pt-BR", { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' })}</Text>
        </Amount>
      )}
      <TypeService padding={'25px 40px 0px'}>
        <Text>
          {taskIcon && (
            <Icon src={taskIcon}></Icon>
          )}
          {data.service_name}
        </Text>
        <Text primary color={ticket ? getStatusColorTicket() : getStatusColorInvoice()}>
        {ticket ? getStatusTicket() : getStatusInvoice()}
        </Text>
        <Link to={`/pedidos/${data.task_id}/orcamentos`}>
          <Text primary button bold color={colors.primary} marginbottom={'0'} margintop={15}>VER PEDIDO</Text>
        </Link>
      </TypeService>
      <TypeService padding={'30px 40px 0px'}>
        <Text primary>
          <Image
            src={data.pro_picture || iconProfile}
            size="small"
            rounded
          />
          {data.pro_name}
        </Text>
        {ticket && (
          <Text primary>
            <Image
              src={data.cli_picture || iconProfile}
              size="small"
              rounded
            />
            {data.cli_name}
          </Text>
        )}
      </TypeService>
      <TypeService width={'auto'}>
        <Icon width={50} height={50} marginbottom={10} marginright={'0'} src={pdf}></Icon>
        <Text
          onClick={() => openNfs()}
          button
          primary
          bold
          oneline
          color={colors.primary}
          marginbottom={'0'}>
            BAIXAR {invoice ? 'NOTA' : 'BOLETO'}
        </Text>
      </TypeService>
    </Container>
  )

}

export default Row
